/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Column } from '@g17eco/molecules/tracking-list';
import { ScopeQuestionGroupOptionalValue } from '../../../../types/survey';
import { GroupLogo } from '../../../survey-question-list/partials/GroupTitle';
import { InheritedIcon } from '../../../survey/scope-group/InheritedIcon';
import { QUESTION } from '../../../../constants/terminology';

export const GroupColumnName = (props: {
  questionGroup: ScopeQuestionGroupOptionalValue;
}) => {
  const { questionGroup } = props;

  return (
    <Column stretch truncate className='d-flex align-items-center'>
      <div>
        {questionGroup.groupData?.isInherited ? <InheritedIcon /> : null}
        <GroupLogo questionGroup={questionGroup} />
      </div>
      <div className='d-flex flex-column gap-2'>
        <div className='text-ThemeTextDark'>{questionGroup.groupName}</div>
        <div>
          <span className='text-ThemeTextLight'>
            {questionGroup.list.length} {QUESTION.SINGULAR}
            {questionGroup.count === 1 ? '' : 's'}
          </span>
        </div>
      </div>
    </Column>
  );
};
